import { AuthService } from './auth/auth.service';
import { SharedService } from './shared/shared.service';
import { SettingsService } from './settings/settings.service';
import { OrderService } from './order/shared/order.service';
import { Component, OnInit } from '@angular/core';

@Component({
    // tslint:disable-next-line
    selector: 'body',
    template: '<router-outlet></router-outlet>',
    providers: [AuthService]

})
export class AppComponent implements OnInit {
    user: any;
    roles: any;

    constructor(
        public auth: AuthService,
        public sharedService: SharedService,
        public orderService: OrderService,
        public settingsService: SettingsService,
    ) {

        
       
    }

    ngOnInit() {
        this.auth.handleAuthentication();
        // Promise.resolve(this.getUser()).then(() => {
        //     this.orderService.getFavoritesForUser(this.user.role).subscribe();
        // });
    }

    getUser() {
        this.user = JSON.parse(localStorage.getItem('user'));
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts